const combine = (url, path) => (
  path ? `${url.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}` : url
);

export default combine;
